<div class="scrollbar" ng-if="!$ctrl.listOptions.listOnly">
    <ul>
        <li ng-repeat="item in $ctrl.items track by $index" ng-class="{ keylight: $ctrl.showKeyHighlight($index) }" title="{{$ctrl.title(item)}}">
            <c-list-item options="$ctrl.listOptions" render-item-as="$ctrl.itemTemplate" item-height="$ctrl.normalizedItemHeight" highlight="$ctrl.highlight" on-click="$ctrl.onItemClick(item)" on-select="$ctrl.onItemSelect(item, viaCheckBox)" selected-item-ids="$ctrl.selectedIds" item="item" index="$index"></c-list-item>
        </li>
    </ul>
</div>